// @ts-nocheck
import React, { useEffect, useState } from "react";
import { sfCategories } from "../../../config";
import useAccountEnhanced from "../../../hooks/use-account-enhanced";

interface AtFault {
    EmployeeCode: string;
    Role: string;
    ReasonCategory: string;
}

interface SFAtFaultProps {
    initialAtFaults: AtFault[];
    onAtFaultsChange: (atFaults: AtFault[]) => void;
}

const SFAtFault: React.FC<SFAtFaultProps> = ({
    initialAtFaults,
    onAtFaultsChange,
}) => {
    const [roles, setRoles] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [atFaults, setAtFaults] = useState<AtFault[]>(initialAtFaults);
    const accountEnhanced = useAccountEnhanced();

    useEffect(() => {
        onAtFaultsChange(atFaults);
    }, [atFaults, onAtFaultsChange]);

    useEffect(() => {
        const uniqueRoles = [...new Set(sfCategories.map((item) => item.Role))];
        setRoles(uniqueRoles);
    }, []);

    useEffect(() => {
        if (selectedRole) {
            // Filter categories based on selected role
            const filteredCategories = sfCategories
                .filter((item) => item.Role === selectedRole)
                .map((item) => item.Category);
            setCategories(filteredCategories);
        } else {
            setCategories([]);
        }
    }, [selectedRole]);

    const handleAtFaultRoleChange = (
        event: React.ChangeEvent<HTMLSelectElement>,
    ) => {
        setSelectedRole(event.target.value);
        setSelectedCategory("");
    };

    const handleAtFaultCategoryChange = (
        event: React.ChangeEvent<HTMLSelectElement>,
    ) => {
        setSelectedCategory(event.target.value);
    };

    const handleAtFaultAdd = async () => {
        const data: AtFault = {
            EmployeeCode: accountEnhanced.me.employeeCode.toUpperCase(),
            Role: selectedRole,
            ReasonCategory: selectedCategory,
        };
        setAtFaults([...atFaults, data]);
        setSelectedRole("");
        setSelectedCategory("");
    };

    const handleAtFaultRemove = (index: number) => {
        setAtFaults(atFaults.filter((_, i) => i !== index));
    };

    return (
        <div>
            <div className="card-title">At Fault</div>
            <fieldset className="fieldset w-full">
                <label className="label">
                    <span className="text-white">Role:</span>
                </label>
                <select
                    onChange={handleAtFaultRoleChange}
                    value={selectedRole}
                    className="select select-sm select-bordered text-black"
                >
                    <option value="">Select a role</option>
                    {roles.sort().map((role, index) => (
                        <option key={index} value={role}>
                            {role}
                        </option>
                    ))}
                </select>
            </fieldset>

            <fieldset className="fieldset w-full">
                <label className="label">
                    <span className="text-white">Category: </span>
                </label>
                <select
                    id="category"
                    onChange={handleAtFaultCategoryChange}
                    value={selectedCategory}
                    className="select select-sm text-black"
                >
                    <option value="">Select a category</option>
                    {categories.sort().map((category, index) => (
                        <option key={index} value={category}>
                            {category}
                        </option>
                    ))}
                </select>
            </fieldset>

            <div className="mt-4">
                <button
                    onClick={handleAtFaultAdd}
                    disabled={!selectedRole || !selectedCategory}
                    className="btn btn-sm btn-primary"
                >
                    Add
                </button>
            </div>

            <div style={{ marginTop: "20px" }}>
                <div>Submitted:</div>
                <ul>
                    {atFaults.length === 0 && <div>None.</div>}
                    {atFaults.map((atFault, index) => (
                        <>
                            <div
                                key={index}
                                style={{
                                    display: "flex",
                                    padding: "10px",
                                    marginBottom: "10px",
                                }}
                            >
                                <div>
                                    <button
                                        onClick={() =>
                                            handleAtFaultRemove(index)
                                        }
                                        className="btn btn-sm btn-primary"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Remove
                                    </button>
                                </div>
                                <div>
                                    <p>
                                        <strong>Role:</strong> {atFault.Role}
                                    </p>
                                    <p>
                                        <strong>Category:</strong>{" "}
                                        {atFault.ReasonCategory}
                                    </p>
                                </div>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <hr />
                            </div>
                        </>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SFAtFault;
